import React from "react";
import { Link } from "react-router-dom";
import ComponentWrapper from "../Shared/ComponentWrapper";
import buildWithHelix1 from "../../data/Build-with-Helix-1.json";
import buildWithHelix2 from "../../data/Build-with-Helix-2.json";
import buildWithHelix3 from "../../data/Build-with-Helix-3.json";

import LottieAnimation from "../Shared/LottieAnimation";

const BuildWithHelix = () => {
  return (
    <ComponentWrapper styles="pt-[2rem] sm:pt-[5rem]">
      <div id="developers" className="flex w-full justify-center items-center flex-col gap-4">
        <h2 className="text-[40px] leading-[48px] text-center text-black font-medium">
          Why Helix AI.
        </h2>
        <p className="text-[18px] max-w-[620px] text-center text-gray-1 font-normal">
          A smarter way to interact with the blockchain — whether you're a
          developer, trader, or just getting started in crypto.
        </p>
        <div className="w-full grid pt-5 sm:pt-9 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-7">
          {buildWithHelixData.map((item, index) => {
            return (
              <div
                key={index}
                className="w-full flex flex-col bg-white border-[1px] border-[#F0F0F5] rounded-[24px]"
              >
                <div className="w-full h-[200px]">
                  <LottieAnimation
                    animationData={item.animationData}
                    width="100%"
                    height="100%"
                  />
                </div>
                <div className="flex flex-col py-6 justify-center items-center gap-3 px-6">
                  <p className="text-blue-1 text-[20px] font-medium">
                    {item.title}
                  </p>
                  <p className="text-[16px] text-gray-1 text-center font-medium">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <Link
          to="/docs"
          className="text-[14px] mt-[1.5rem] z-40 font-semibold text-white h-[46px] rounded-[12px] bg-blue-1 px-6
                       transition-all duration-200 ease-in-out
                      shadow-md hover:shadow-lg active:shadow-sm
                      transform hover:scale-105 active:scale-95 flex items-center justify-center"
        >
          Documentation
        </Link>
      </div>
    </ComponentWrapper>
  );
};

export default BuildWithHelix;

const buildWithHelixData = [
  {
    title: "Natural Language Interface",
    description:
      "No complex UIs to learn. Just tell the AI what you want to do and it handles the rest — from simple transfers to multi-step workflows.",
    animationData: buildWithHelix1,
  },
  {
    title: "Built on Ethereum",
    description:
      "Native to Ethereum mainnet — swap, transfer, deploy, and track your portfolio on the most secure smart contract network, all from a single conversation.",
    animationData: buildWithHelix2,
  },
  {
    title: "Non-Custodial & Secure",
    description:
      "Connect any wallet and stay in control. Helix AI uses session-based signing so your keys and assets are always yours.",
    animationData: buildWithHelix3,
  },
];
